import React from "react";
import { useStrings } from "../../../hooks/useStrings";

interface SplashScreenProps {
  orgConfig: {
    bgImgURI: string;
    logoURI: string;
    btnColor: string;
    btnTextColor: string;
  };
  onTapToStart: (event: string) => void;
}

const SplashScreen: React.FC<SplashScreenProps> = ({
  orgConfig,
  onTapToStart,
}) => {
  const S = useStrings();
  const handleStart = () => {
    onTapToStart("Start");
  };

  const buttonStyle = {
    color: orgConfig.btnTextColor,
    backgroundColor: orgConfig.btnColor,
  };

  const backgroundStyle = {
    backgroundImage: `url(${orgConfig.bgImgURI})`,
  };

  return (
    <div className="main-screen">
      <div className="screen-outer splash-screen" style={backgroundStyle}>
        <div className="screen-inner">
          <div className="screen-subinner">
            <div className="screen-header-logo">
              <img src={orgConfig.logoURI} alt="Visitly" />
            </div>
            <div className="screen-footer">
              <button
                className="btn btn-white btn-padding btn-shadow"
                style={buttonStyle}
                onClick={handleStart}
              >
                {S.SPLASH_SCREEN.TAP_TO_START}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
